module.exports = __webpack_public_path__ + "img/bois.85c1016f.svg";